import * as React from 'react';
import * as classNames from "classnames";
import MediaQuery from 'react-responsive';
import { withTheme } from "../../common/withTheme";

interface IMenuProps {
    theme?: string;
    className?: string;
}

interface IMenuActions {

}

type MenuProps = IMenuProps & IMenuActions;

interface IMenuState {
    showMenu: boolean;
}

class Menu extends React.Component<MenuProps, any> {
    constructor(props, context) {
        super(props, context);

        this.state = {
            showMenu: false
        }

        this.toggleMenu = this.toggleMenu.bind(this);
    }

    toggleMenu() {
        this.setState({ showMenu: !this.state.showMenu });
    }

    render() {
        return <>
            <MediaQuery maxWidth={767}>
                <button className="d-md-none btn btn-light mr-auto px-3 py-1 mb-1" type="button" data-toggle="collapse" data-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation" onClick={this.toggleMenu}>
                    <i className="fa fa-bars"></i>
                </button>
                <nav className="navbar navbar-expand-md p-0 bg-none navbar-child position-absolute w-100">
                    <div className={classNames(this.props.theme, this.props.className, "collapse navbar-collapse", { "show": this.state.showMenu })}>
                        {this.props.children}
                    </div>
                </nav>
            </MediaQuery>
            <MediaQuery minWidth={768}>
                <nav className="navbar navbar-expand-md p-0 bg-none">
                    <div className={classNames(this.props.theme, this.props.className, "collapse navbar-collapse", { "show": this.state.showMenu })}>
                        {this.props.children}
                    </div>
                </nav>
            </MediaQuery>

        </>;
    }
}

export default withTheme<MenuProps>(Menu);